// Maps existing CompanyAccount section hooks to subscription modules.
export const COMPANY_SECTION_MODULES = {
  dashboard: "dashboard", sales: "sales", quatations: "sales", discount: "sales",
  subscriptions: "sales", draft: "sales", sell_return: "sales",
  items: "inventory", "item-explore-display": "inventory", "add-new-item": "inventory",
  "edit-item-display": "inventory", imports: "inventory", price_groups: "inventory",
  units: "inventory", brands: "inventory", categories: "inventory", variations: "inventory",
  services: "inventory", openingstock: "inventory", reconciliation: "inventory",
  adjusment: "inventory", product_services: "inventory", production: "inventory",
  orders: "purchase", recieves: "purchase", returns: "purchase",
  "place-new-order": "purchase", "purchase-order-preview": "purchase",
  deliveries: "inventory", transfers: "inventory", taxrate: "finance",
  expenses: "finance", expense_category: "finance", invoicing: "finance",
  reports_main: "reports", users: "staff", Staff: "staff",
};
export const COMPANY_SECTION_CAPABILITIES = {
  "add-new-item": "inventory.create", "edit-item-display": "inventory.edit",
  imports: "inventory.import", "sell_return": "sales.refund",
  "place-new-order": "purchase.create", "purchase-order-preview": "purchase.view",
  openingstock: "inventory.create", reports_main: "reports.dashboard",
};
